import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Plus } from 'lucide-react';
import { useVideoLessons } from './hooks/useVideoLessons';
import { VideoLessonDialog, VideoLessonsTable } from './components';
import { ErrorState, PageHeader, Toolbar } from '@/components/app';
import { formatTashkentShort } from '@/lib/datetime';

export default function VideoLessonsPage() {
  const {
    videoLessons,
    isLoading,
    loadError,
    retryLoad,
    isCreateDialogOpen,
    isEditDialogOpen,
    editingLesson,
    formData,
    isSubmitting,
    setIsCreateDialogOpen,
    setIsEditDialogOpen,
    setFormData,
    handleCreate,
    handleEdit,
    handleUpdate,
    handleDelete,
    handleToggleActive,
  } = useVideoLessons();

  const activeCount = videoLessons.filter((l) => l.is_active).length;

  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Видеоуроки"
        subtitle="Раздел «Video» в библиотеке приложения, в порядке сортировки"
        actions={
          <Button onClick={() => setIsCreateDialogOpen(true)}>
            <Plus aria-hidden />
            Создать видеоурок
          </Button>
        }
      />

      <Card className="overflow-hidden">
        {loadError ? (
          <ErrorState message={loadError} onRetry={retryLoad} />
        ) : (
          <>
            <Toolbar
              title={isLoading ? 'Загрузка…' : `Уроков: ${videoLessons.length}`}
              end={!isLoading && videoLessons.length > 0 ? <span>В приложении: {activeCount}</span> : undefined}
            />
            <VideoLessonsTable
              videoLessons={videoLessons}
              isLoading={isLoading}
              selectedId={isEditDialogOpen ? editingLesson?.id ?? null : null}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onToggleActive={handleToggleActive}
              formatDate={(value) => (value ? formatTashkentShort(value) : '—')}
              onCreate={() => setIsCreateDialogOpen(true)}
            />
          </>
        )}
      </Card>

      <VideoLessonDialog
        isOpen={isCreateDialogOpen}
        onOpenChange={setIsCreateDialogOpen}
        formData={formData}
        onFormDataChange={setFormData}
        onSubmit={handleCreate}
        isSubmitting={isSubmitting}
        title="Новый видеоурок"
        description="Появится в разделе «Video» библиотеки"
        submitLabel="Создать"
      />

      <VideoLessonDialog
        isOpen={isEditDialogOpen}
        onOpenChange={setIsEditDialogOpen}
        formData={formData}
        onFormDataChange={setFormData}
        onSubmit={handleUpdate}
        isSubmitting={isSubmitting}
        title="Редактировать видеоурок"
        description="Изменения увидят пользователи при следующем открытии библиотеки"
        submitLabel="Сохранить"
      />
    </div>
  );
}
